import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function useFetch(url, params, dep) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(!!url);
  const key = JSON.stringify(params || {});
  const load = useCallback(async () => {
    if (!url) return;
    setLoading(true);
    try {
      const r = await api.get(url, { params: JSON.parse(key) });
      setData(r.data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  }, [url, key]);
  useEffect(() => {
    load();
  }, [load, dep]);
  return { data, loading, reload: load, setData };
}
